import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";

export class StickerButton extends SceneDraggable {
    protected cancelSelectionWhenAnotherDragStarts = true;

    protected dropShadow?: PIXI.Sprite;

    constructor() {
        super();
    }

    public get stickerTexture() {
        return this.sprite.texture;
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        super.setLayoutTexture(texture, anchorX, anchorY);
        if (typeof texture === "string") {
            this.name = texture;
            if (this.dropShadow === undefined) {
                this.dropShadow = HLF.PixiUtils.makeSprite(texture + "_shadow");
            }
            else {
                this.dropShadow.texture = HLF.PixiUtils.getTexture(texture + "_shadow");
            }
        }
    }

    // after position and scale have been set
    public onLayout() {
        if (this.dropShadow !== undefined) {
            this._visuals.addChildAt(this.dropShadow, 0);
            // line up top of shadow sprite with top of image, which seems to be close enough...
            this.dropShadow.anchor.set(0.5, 0);
            this.dropShadow.position.set(0, -this.sprite.height / 2);
        }
    }
/*
    public dragBegin() {
        super.dragBegin();
        this.dropShadow?.scale.set(1.05);
    }

    public dragEnd() {
        super.dragEnd();
        this.dropShadow?.scale.set(1);
    }

    public select() {
        super.select();
        this.dropShadow?.scale.set(1.05);
    }

    public deselect() {
        super.deselect();
        this.dropShadow?.scale.set(1);
    }
*/
}